export const DataExtractionInput = {
    files: [], // Array of {file_name: string, pdf_data: Base64 encoded string, password: string (optional)}
    enrich: false,
    output_format: "json",
    store_if_invalid: true,
    iso_dateformat: true,
};